import { useContext } from 'react';
import OrganizationContext from './organization-context';

export const useOrganization = () => {
    return useContext(OrganizationContext);
};
